import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import GlobalMessageBoard from "../common/global-message-board";
import FooterPP from "../common/FooterPP";
import CarouselContainer from "../common/global-carousel/CarouselContainer";
import { useSelector } from "react-redux";
import messages from "components/messagesDescription";
import ImageSlide from "../common/global-carousel/ImageSlide";
import QRCode from "qrcode.react";

const DownloadButtons = ({ iosUrl, androidUrl }) => (
  <Fragment>
    <a href={iosUrl}>
      <img src="/assets/images/app-store.png" alt="app-store" className="download-image" />
    </a>
    <a href={androidUrl}>
      <img src="/assets/images/google-play.png" alt="google-play" className="download-image" />
    </a>
  </Fragment>
);

DownloadButtons.propTypes = {
  iosUrl: PropTypes.string.isRequired,
  androidUrl: PropTypes.string.isRequired,
};

const LoginLayout = ({ children, client, intl }) => {
  const clientSettings = useSelector(state => state.common.clientSettings);
  const currentImageIndex = useSelector(state => state.carousel.currentImageIndex);
  const [qrCodeSize, setQrCodeSize] = useState(130);

  useEffect(() => {
    const updateSize = () => {
      let size = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;
      const screenWidth = window.innerWidth;
      size = (size * screenWidth) / 10000;
      setQrCodeSize(size);
    };

    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const images = clientSettings.backgroundImages;

  const androidUrl = "https://play.google.com/store/apps/details?id=com.pacificprimecxa.android";
  const iosUrl = "https://apps.apple.com/us/app/pacific-prime-cxa-benefits/id6462017741";
  const qrCodeUrl = window.location.origin + "/qr-redirect-os";

  return (
    <div>
      <div
        style={{
          backgroundColor: "pink",
          position: "sticky",
          left: "0",
          top: "0",
          zIndex: "100",
        }}
      >
        <GlobalMessageBoard />
      </div>
      <div className="main-container">
        <div className="grid-container">
          <div className="left-column">{children}</div>
          <div className="mobile-download-section">
            <div className="download-section">
              <DownloadButtons iosUrl={iosUrl} androidUrl={androidUrl} />
            </div>
          </div>
          <div className="right-column">
            <div className="image-container">
              {images ? (
                <CarouselContainer
                  images={images}
                  hasArrow={false}
                  width={"100%"}
                  height={"90vh"}
                  paginationPosition={{ left: "51%", top: "90%" }}
                />
              ) : (
                <ImageSlide
                  url={"/assets/images/login-page-image.jpg"}
                  width={"100%"}
                  height={"90vh"}
                />
              )}
              {currentImageIndex === 0 && (
                <div>
                  <div className="image-overlay">
                    <h2 className="image-title">
                      {intl.formatMessage(messages.welcomeToDescription)}{" "}
                      <span className="highlight">
                        {intl.formatMessage(messages.pacificPrimePortalDescription)}
                      </span>
                    </h2>
                  </div>
                  <div className="download-container">
                    <div className="download-section">
                      <h2 className="download-title">
                        {intl.formatMessage(messages.downloadDescription)}
                      </h2>
                      <DownloadButtons iosUrl={iosUrl} androidUrl={androidUrl} />
                    </div>
                    <div className="qr-code-section">
                      <h2 className="qr-code-title">
                        {intl.formatMessage(messages.scanQRCodeDescription)}
                      </h2>
                      <div className="qr-code">
                        <QRCode value={qrCodeUrl} size={qrCodeSize} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <FooterPP client={client} />
      </div>
    </div>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.node.isRequired,
  client: PropTypes.object,
  intl: intlShape.isRequired,
};

export default injectIntl(LoginLayout);



// WEBPACK FOOTER //
// ./components/login/LoginLayoutPP.jsx